export class XmlSchema {
  public constructor(public xsdNodes: Map<string, Element>) {}

  findXsdNodeForTagName(tagName: string): Node {
    return this.xsdNodes.get(tagName);
  }
}
